var map = {
	"./add-capa-report/add-capa-report.module": [
		"./src/app/capa-management/add-capa-report/add-capa-report.module.ts",
		"default~add-capa-report-add-capa-report-module~capa-record-capa-record-module~findings-record-findin~0129a56c",
		"common",
		"add-capa-report-add-capa-report-module"
	],
	"./add-injured-person/add-injured-person.module": [
		"./src/app/incident/add-injured-person/add-injured-person.module.ts",
		"add-injured-person-add-injured-person-module"
	],
	"./add-reporting/incident-reporting.module": [
		"./src/app/incident/add-reporting/incident-reporting.module.ts",
		"common",
		"add-reporting-incident-reporting-module"
	],
	"./admin-login/admin-login.module": [
		"./src/app/login/admin-login/admin-login.module.ts",
		"default~admin-login-admin-login-module~contractor-login-contractor-login-module~login-login-module",
		"common",
		"admin-login-admin-login-module"
	],
	"./announcement/announcement-detail/announcement-detail.module": [
		"./src/app/basic-modules/announcement/announcement-detail/announcement-detail.module.ts",
		"announcement-announcement-detail-announcement-detail-module"
	],
	"./announcement/announcement/announcement.module": [
		"./src/app/basic-modules/announcement/announcement/announcement.module.ts",
		"announcement-announcement-announcement-module"
	],
	"./app-login/app-login.module": [
		"./src/app/login/app-login/app-login.module.ts",
		"app-login-app-login-module"
	],
	"./auto-immediate-inspection/auto-immediate-inspection.module": [
		"./src/app/login/auto-immediate-inspection/auto-immediate-inspection.module.ts",
		"auto-immediate-inspection-auto-immediate-inspection-module"
	],
	"./auto-immediate-observation/auto-immediate-observation.module": [
		"./src/app/login/auto-immediate-observation/auto-immediate-observation.module.ts",
		"auto-immediate-observation-auto-immediate-observation-module"
	],
	"./auto-issue-reporting/auto-issue-reporting.module": [
		"./src/app/login/auto-issue-reporting/auto-issue-reporting.module.ts",
		"auto-issue-reporting-auto-issue-reporting-module"
	],
	"./auto-login/auto-login.module": [
		"./src/app/login/auto-login/auto-login.module.ts",
		"auto-login-auto-login-module"
	],
	"./basic-modules/basic-modules.module": [
		"./src/app/basic-modules/basic-modules.module.ts",
		"basic-modules-basic-modules-module"
	],
	"./basic-modules/help-center/help-center.module": [
		"./src/app/basic-modules/help-center/help-center.module.ts",
		"basic-modules-help-center-help-center-module"
	],
	"./bbso/bbso-corrective/bbso-corrective.module": [
		"./src/app/inspection/bbso/bbso-corrective/bbso-corrective.module.ts",
		"bbso-bbso-corrective-bbso-corrective-module"
	],
	"./bbso/immediate-observation/immediate-observation.module": [
		"./src/app/inspection/bbso/immediate-observation/immediate-observation.module.ts",
		"bbso-immediate-observation-immediate-observation-module"
	],
	"./bbso/immediate-observation/observation-form/observation-form.module": [
		"./src/app/inspection/bbso/immediate-observation/observation-form/observation-form.module.ts",
		"bbso-immediate-observation-observation-form-observation-form-module"
	],
	"./bbso/observation-record/record-observation.module": [
		"./src/app/inspection/bbso/observation-record/record-observation.module.ts",
		"bbso-observation-record-record-observation-module"
	],
	"./bbso/observation-record/scheduling-observation-detail/plan-observation.module": [
		"./src/app/inspection/bbso/observation-record/scheduling-observation-detail/plan-observation.module.ts",
		"bbso-observation-record-scheduling-observation-detail-plan-observation-module"
	],
	"./capa-management/capa-management.module": [
		"./src/app/capa-management/capa-management.module.ts",
		"capa-management-capa-management-module"
	],
	"./capa-record/capa-record.module": [
		"./src/app/capa-management/capa-record/capa-record.module.ts",
		"default~add-capa-report-add-capa-report-module~capa-record-capa-record-module~findings-record-findin~0129a56c",
		"common",
		"capa-record-capa-record-module"
	],
	"./company/contractor-company.module": [
		"./src/app/contractor/company/contractor-company.module.ts",
		"company-contractor-company-module"
	],
	"./components/pic-single/pic-single.module": [
		"./src/app/shared/components/pic-single/pic-single.module.ts",
		"components-pic-single-pic-single-module"
	],
	"./components/preview-file/preview-file.module": [
		"./src/app/shared/components/preview-file/preview-file.module.ts",
		"default~components-preview-file-preview-file-module~components-view-ppt-view-ppt-module",
		"common",
		"components-preview-file-preview-file-module"
	],
	"./components/turn-to-send/turn-to-send.module": [
		"./src/app/shared/components/turn-to-send/turn-to-send.module.ts",
		"components-turn-to-send-turn-to-send-module"
	],
	"./components/view-ppt/view-ppt.module": [
		"./src/app/shared/components/view-ppt/view-ppt.module.ts",
		"default~components-preview-file-preview-file-module~components-view-ppt-view-ppt-module",
		"common",
		"components-view-ppt-view-ppt-module"
	],
	"./contractor-login/contractor-login.module": [
		"./src/app/login/contractor-login/contractor-login.module.ts",
		"default~admin-login-admin-login-module~contractor-login-contractor-login-module~login-login-module",
		"common",
		"contractor-login-contractor-login-module"
	],
	"./contractor/contractor.module": [
		"./src/app/contractor/contractor.module.ts",
		"contractor-contractor-module"
	],
	"./corrective-record/record-corrective.module": [
		"./src/app/inspection/corrective-record/record-corrective.module.ts",
		"corrective-record-record-corrective-module"
	],
	"./corrective/contractor-corrective.module": [
		"./src/app/contractor/corrective/contractor-corrective.module.ts",
		"corrective-contractor-corrective-module"
	],
	"./corrective/incident-corrective.module": [
		"./src/app/incident/corrective/incident-corrective.module.ts",
		"default~corrective-incident-corrective-module~investigation-incident-investigation-module~investigat~74b1eba7",
		"common",
		"corrective-incident-corrective-module"
	],
	"./corrective/sign-off-turn/sign-off-turn.module": [
		"./src/app/incident/corrective/sign-off-turn/sign-off-turn.module.ts",
		"corrective-sign-off-turn-sign-off-turn-module"
	],
	"./ehs-inspection/ehs-inspection.module": [
		"./src/app/inspection/ehs-inspection/ehs-inspection.module.ts",
		"default~ehs-inspection-ehs-inspection-module~inspection-inspection-module",
		"common",
		"ehs-inspection-ehs-inspection-module"
	],
	"./employee/contractor-employee.module": [
		"./src/app/contractor/employee/contractor-employee.module.ts",
		"employee-contractor-employee-module"
	],
	"./evaluation/contractor-evaluation.module": [
		"./src/app/contractor/evaluation/contractor-evaluation.module.ts",
		"evaluation-contractor-evaluation-module"
	],
	"./findings-record/findings-record-detail/findings-record-detail.module": [
		"./src/app/capa-management/findings-record/findings-record-detail/findings-record-detail.module.ts",
		"default~add-capa-report-add-capa-report-module~capa-record-capa-record-module~findings-record-findin~0129a56c",
		"common",
		"findings-record-findings-record-detail-findings-record-detail-module"
	],
	"./findings-record/findings-record.module": [
		"./src/app/capa-management/findings-record/findings-record.module.ts",
		"default~add-capa-report-add-capa-report-module~capa-record-capa-record-module~findings-record-findin~0129a56c",
		"common",
		"findings-record-findings-record-module"
	],
	"./gmp-cn-inspection/customized-inspection/customized-inspection.module": [
		"./src/app/gmp-cn-inspection/customized-inspection/customized-inspection.module.ts",
		"default~gmp-cn-inspection-customized-inspection-customized-inspection-module~gmp-cn-inspection-gmp-c~7fcc5635",
		"common",
		"gmp-cn-inspection-customized-inspection-customized-inspection-module"
	],
	"./gmp-cn-inspection/gmp-cn-inspection.module": [
		"./src/app/gmp-cn-inspection/gmp-cn-inspection.module.ts",
		"default~gmp-cn-inspection-customized-inspection-customized-inspection-module~gmp-cn-inspection-gmp-c~7fcc5635",
		"common",
		"gmp-cn-inspection-gmp-cn-inspection-module"
	],
	"./gmp-inspection/gmp-inspection.module": [
		"./src/app/gmp-inspection/gmp-inspection.module.ts",
		"default~gmp-inspection-gmp-inspection-module~record-gmp-inspection-record-gmp-inspection-module",
		"common",
		"gmp-inspection-gmp-inspection-module"
	],
	"./incident/incident.module": [
		"./src/app/incident/incident.module.ts",
		"incident-incident-module"
	],
	"./inspection-form/inspection-form.module": [
		"./src/app/gmp-inspection/inspection-form/inspection-form.module.ts",
		"inspection-form-inspection-form-module"
	],
	"./inspection-record/record-inspection.module": [
		"./src/app/inspection/inspection-record/record-inspection.module.ts",
		"inspection-record-record-inspection-module"
	],
	"./inspection/contractor-inspection.module": [
		"./src/app/contractor/inspection/contractor-inspection.module.ts",
		"inspection-contractor-inspection-module"
	],
	"./inspection/inspection.module": [
		"./src/app/inspection/inspection.module.ts",
		"default~ehs-inspection-ehs-inspection-module~inspection-inspection-module",
		"common",
		"inspection-inspection-module"
	],
	"./inspection/legacy-routes/immediate-inspection-redirect/immediate-inspection-redirect.module": [
		"./src/app/inspection/legacy-routes/immediate-inspection-redirect/immediate-inspection-redirect.module.ts",
		"inspection-legacy-routes-immediate-inspection-redirect-immediate-inspection-redirect-module"
	],
	"./investigation/corrective-actions-detail/corrective-actions-detail.module": [
		"./src/app/incident/investigation/corrective-actions-detail/corrective-actions-detail.module.ts",
		"investigation-corrective-actions-detail-corrective-actions-detail-module"
	],
	"./investigation/incident-investigation.module": [
		"./src/app/incident/investigation/incident-investigation.module.ts",
		"default~corrective-incident-corrective-module~investigation-incident-investigation-module~investigat~74b1eba7",
		"common",
		"investigation-incident-investigation-module"
	],
	"./investigation/incident-task-content/task-content.module": [
		"./src/app/incident/investigation/incident-task-content/task-content.module.ts",
		"default~corrective-incident-corrective-module~investigation-incident-investigation-module~investigat~74b1eba7",
		"common",
		"investigation-incident-task-content-task-content-module"
	],
	"./investigation/sign/sign-detail.module": [
		"./src/app/incident/investigation/sign/sign-detail.module.ts",
		"investigation-sign-sign-detail-module"
	],
	"./issue-record/issue-record.module": [
		"./src/app/inspection/issue-record/issue-record.module.ts",
		"issue-record-issue-record-module"
	],
	"./login/login.module": [
		"./src/app/login/login.module.ts",
		"default~admin-login-admin-login-module~contractor-login-contractor-login-module~login-login-module",
		"common",
		"login-login-module"
	],
	"./message-center/message-center.module": [
		"./src/app/basic-modules/message/message-center/message-center.module.ts",
		"message-center-message-center-module"
	],
	"./message-detail/message-detail.module": [
		"./src/app/basic-modules/message/message-detail/message-detail.module.ts",
		"message-detail-message-detail-module"
	],
	"./message/message.module": [
		"./src/app/basic-modules/message/message.module.ts",
		"message-message-module"
	],
	"./project/contractor-project.module": [
		"./src/app/contractor/project/contractor-project.module.ts",
		"project-contractor-project-module"
	],
	"./record-gmp-corrective/record-gmp-corrective.module": [
		"./src/app/gmp-inspection/record-gmp-corrective/record-gmp-corrective.module.ts",
		"record-gmp-corrective-record-gmp-corrective-module"
	],
	"./record-gmp-finding/record-gmp-finding.module": [
		"./src/app/gmp-inspection/record-gmp-finding/record-gmp-finding.module.ts",
		"record-gmp-finding-record-gmp-finding-module"
	],
	"./record-gmp-inspection/record-gmp-inspection.module": [
		"./src/app/gmp-inspection/record-gmp-inspection/record-gmp-inspection.module.ts",
		"default~gmp-inspection-gmp-inspection-module~record-gmp-inspection-record-gmp-inspection-module",
		"common",
		"record-gmp-inspection-record-gmp-inspection-module"
	],
	"./record/incident-inquiry.module": [
		"./src/app/incident/record/incident-inquiry.module.ts",
		"default~corrective-incident-corrective-module~investigation-incident-investigation-module~investigat~74b1eba7",
		"common",
		"record-incident-inquiry-module"
	],
	"./report-accident/report-accident.module": [
		"./src/app/report/report-accident/report-accident.module.ts",
		"default~report-accident-report-accident-module~report-audit-report-audit-module~report-bbso-report-b~e28dd256",
		"common",
		"report-accident-report-accident-module"
	],
	"./report-audit/report-audit.module": [
		"./src/app/report/report-audit/report-audit.module.ts",
		"default~report-accident-report-accident-module~report-audit-report-audit-module~report-bbso-report-b~e28dd256",
		"common",
		"report-audit-report-audit-module"
	],
	"./report-bbso/report-bbso.module": [
		"./src/app/report/report-bbso/report-bbso.module.ts",
		"default~report-accident-report-accident-module~report-audit-report-audit-module~report-bbso-report-b~e28dd256",
		"common",
		"report-bbso-report-bbso-module"
	],
	"./report-contractor/report-contractor.module": [
		"./src/app/report/report-contractor/report-contractor.module.ts",
		"default~report-accident-report-accident-module~report-audit-report-audit-module~report-bbso-report-b~e28dd256",
		"common",
		"report-contractor-report-contractor-module"
	],
	"./report-gmp-cn/dashboard.module": [
		"./src/app/report/report-gmp-cn/dashboard.module.ts",
		"report-gmp-cn-dashboard-module"
	],
	"./report-gmp/report-gmp.module": [
		"./src/app/report/report-gmp/report-gmp.module.ts",
		"default~report-accident-report-accident-module~report-audit-report-audit-module~report-bbso-report-b~e28dd256",
		"common",
		"report-gmp-report-gmp-module"
	],
	"./report-inspection/report-inspection.module": [
		"./src/app/report/report-inspection/report-inspection.module.ts",
		"default~report-accident-report-accident-module~report-audit-report-audit-module~report-bbso-report-b~e28dd256",
		"common",
		"report-inspection-report-inspection-module"
	],
	"./report-risk/report-risk.module": [
		"./src/app/report/report-risk/report-risk.module.ts",
		"default~report-accident-report-accident-module~report-audit-report-audit-module~report-bbso-report-b~e28dd256",
		"common",
		"report-risk-report-risk-module"
	],
	"./report/report.module": [
		"./src/app/report/report.module.ts",
		"report-report-module"
	],
	"./risk-heat-map/risk-heat-map.module": [
		"./src/app/report/risk-heat-map/risk-heat-map.module.ts",
		"risk-heat-map-risk-heat-map-module"
	],
	"./setting-host/setting-host.module": [
		"./src/app/basic-modules/setting-host/setting-host.module.ts",
		"setting-host-setting-host-module"
	],
	"./shared/shared-pages.module": [
		"./src/app/shared/shared-pages.module.ts",
		"shared-shared-pages-module"
	],
	"./tab-home/tab-home.module": [
		"./src/app/tabs/tab-home/tab-home.module.ts",
		"common",
		"tab-home-tab-home-module"
	],
	"./tab-mine/tab-mine.module": [
		"./src/app/tabs/tab-mine/tab-mine.module.ts",
		"common",
		"tab-mine-tab-mine-module"
	],
	"./tab-records-details/tab-records-details.module": [
		"./src/app/tabs/tab-records/tab-records-details/tab-records-details.module.ts",
		"tab-records-details-tab-records-details-module"
	],
	"./tab-records/tab-records.module": [
		"./src/app/tabs/tab-records/tab-records.module.ts",
		"tab-records-tab-records-module"
	],
	"./tab-report/tab-report.module": [
		"./src/app/tabs/tab-report/tab-report.module.ts",
		"tab-report-tab-report-module"
	],
	"./tabs/tabs.module": [
		"./src/app/tabs/tabs.module.ts",
		"tabs-tabs-module"
	],
	"./work/contractor-work.module": [
		"./src/app/contractor/work/contractor-work.module.ts",
		"work-contractor-work-module"
	],
	"src/app/gmp-cn-inspection/plan-inspection/plan-inspection.module": [
		"./src/app/gmp-cn-inspection/plan-inspection/plan-inspection.module.ts",
		"src-app-gmp-cn-inspection-plan-inspection-plan-inspection-module"
	],
	"src/app/gmp-inspection/plan-inspection/plan-inspection.module": [
		"./src/app/gmp-inspection/plan-inspection/plan-inspection.module.ts",
		"src-app-gmp-inspection-plan-inspection-plan-inspection-module"
	],
	"src/app/inspection/ehs-inspection/immediate-inspection/immediate-inspection.module": [
		"./src/app/inspection/ehs-inspection/immediate-inspection/immediate-inspection.module.ts",
		"src-app-inspection-ehs-inspection-immediate-inspection-immediate-inspection-module"
	],
	"src/app/inspection/ehs-inspection/issue-reporting/issue-reporting.module": [
		"./src/app/inspection/ehs-inspection/issue-reporting/issue-reporting.module.ts",
		"src-app-inspection-ehs-inspection-issue-reporting-issue-reporting-module"
	],
	"src/app/inspection/ehs-inspection/plan-inspection/plan-inspection.module": [
		"./src/app/inspection/ehs-inspection/plan-inspection/plan-inspection.module.ts",
		"src-app-inspection-ehs-inspection-plan-inspection-plan-inspection-module"
	],
	"src/app/inspection/ehs-inspection/shared/finding-detail/finding-detail.module": [
		"./src/app/inspection/ehs-inspection/shared/finding-detail/finding-detail.module.ts",
		"src-app-inspection-ehs-inspection-shared-finding-detail-finding-detail-module"
	],
	"src/app/inspection/ehs-inspection/shared/inspection-form/inspection-form.module": [
		"./src/app/inspection/ehs-inspection/shared/inspection-form/inspection-form.module.ts",
		"src-app-inspection-ehs-inspection-shared-inspection-form-inspection-form-module"
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		var id = ids[0];
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "./src/$$_lazy_route_resource lazy recursive";
module.exports = webpackAsyncContext;